import React from 'react';
import PropTypes from 'prop-types';
import { Col, Typography } from 'antd';

const { Text } = Typography;

const Circle = ({ backgroundColor, borderColor }) => (
  <Col flex="40px">
    {backgroundColor && borderColor ? (
      <div
        style={{
          width: 40,
          height: 40,
          borderRadius: '50%',
          backgroundColor,
          color: '#FFFFFF',
          fontWeight: 'bold',
          fontSize: 18,
          border: `3px solid ${borderColor}`,
        }}
      />
    ) : <center><Text style={{ marginBottom: 20, width: 40 }} strong>N/A</Text></center>}
  </Col>
);

Circle.propTypes = {
  backgroundColor: PropTypes.string,
  borderColor: PropTypes.string,
};

Circle.defaultProps = {
  backgroundColor: '',
  borderColor: '',
};

export default Circle;
